import locationsTypes from './locationsTypes'

export const fethOrigin = (payload, target) => {
  return {
    type: locationsTypes.FETCH_ORIGIN_LOCATIONS,
    payload,
    target
  }
}

export const fethOriginSuccess = (payload, target) => {
  return {
    type: locationsTypes.FETCH_ORIGIN_LOCATIONS_SUCCESS,
    payload,
    target
  }
}

export const loadMoreOriginLocations = () => ({
  type: locationsTypes.LOAD_MORE_ORIGIN_LOCATIONS
})

export const setOriginLocationsFilters = (payload) => {
  return {
    type: locationsTypes.SET_ORIGIN_LOCATIONS_FILTERS,
    payload
  }
}

export const startOriginLocationsRequest = (payload) => ({
  type: locationsTypes.START_ORIGIN_LOCATIONS_REQUEST,
  payload
})

export const fethDestination = (payload) => {
  return {
    type: locationsTypes.FETCH_DESTINATION_LOCATIONS,
    payload
  }
}

export const fethDestinationSuccess = (payload) => {
  return {
    type: locationsTypes.FETCH_DESTINATION_LOCATIONS_SUCCESS,
    payload
  }
}

export const loadMoreDestinationLocations = () => ({
  type: locationsTypes.LOAD_MORE_DESTINATION_LOCATIONS
})

export const setDestinationLocationsFilters = (payload) => {
  return {
    type: locationsTypes.SET_DESTINATION_LOCATIONS_FILTERS,
    payload
  }
}

export const startDestinationLocationsRequest = (payload) => ({
  type: locationsTypes.START_DESTINATION_LOCATIONS_REQUEST,
  payload
})
